<template>
    <div>
        <div :class="$style.legend">
            <div :class="$style.item">
                <div :class="[$style.oneWeekOrLess, $style.colorBox]" />
                Storage fees will begin to accrue in 1 week or less.
            </div>
            <div :class="$style.item">
                <div :class="[$style.accruingFees, $style.colorBox]" />
                Storage fees are currently accruing.
            </div>
        </div>
        <el-table
            style="width: 100%"
            max-height="500"
            :data="receiptLogs"
            :row-class-name="rowClassName"
            @row-click="showDetail"
        >
            <template slot="empty"> No receipt logs found. </template>
            <el-table-column :show-overflow-tooltip="false" width="60">
                <template slot="header">
                    <el-checkbox @change="toggleAllSelection" />
                </template>
                <template slot-scope="scope">
                    <el-checkbox
                        v-if="!scope.row.deliveryRequested"
                        :value="isChecked(scope.row)"
                        @change="selectionChange(scope.row, ...arguments)"
                    />
                    <el-tooltip v-else :open-delay="200" placement="top">
                        <div slot="content">
                            One or more units from this log have been requested
                            for delivery.
                        </div>
                        <i class="fa fa-truck" />
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :sortable="column.sortable"
                :sort-method="column.sortMethod"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    <template v-if="scope.column.property === 'availableStock'">
                        <div :class="$style.availableColumn">
                            <span
                                :title="
                                    excludeAvailableWhenZero
                                        ? 'Show all'
                                        : 'Hide rows where available = 0'
                                "
                                @click="
                                    $emit(
                                        'changeExcludeAvailableWhenZero',
                                        !excludeAvailableWhenZero,
                                    )
                                "
                            >
                                {{ scope.column.label }}
                            </span>
                            <i
                                class="fa ml-1"
                                :class="
                                    excludeAvailableWhenZero
                                        ? 'fa-plus-circle'
                                        : 'fa-minus-circle'
                                "
                            />
                        </div>
                    </template>
                    <template v-else> {{ scope.column.label }}</template>
                </template>
                <template slot-scope="scope">
                    <template v-if="scope.column.property === 'id'">
                        <i
                            v-if="scope.row.notes"
                            class="far fa-sticky-note has-notes-icon"
                            title="This item has notes"
                        />
                        <span v-else class="no-notes-spacer" />
                        {{ scope.row.id }}
                    </template>
                    <template v-else-if="scope.column.property === 'date'">
                        {{ formatDate(scope.row.date) }}
                    </template>
                    <template
                        v-else-if="scope.column.property === 'materialType'"
                    >
                        {{
                            `${scope.row.materialType.description} ${scope.row.size} ${scope.row.sizeType}`
                        }}
                    </template>
                    <template v-else>
                        {{ getProp(scope.row, scope.column.property) }}
                    </template>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import _ from "lodash";
import { Checkbox } from "element-ui";
import moment from "moment-timezone";

export default {
    name: "ReceiptLogsTable",
    components: {
        [Checkbox.name]: Checkbox,
    },
    props: {
        receiptLogs: {
            type: Array,
            required: true,
        },
        excludeAvailableWhenZero: {
            type: Boolean,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
        clearSelection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selection: [],
        };
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "Receipt No.",
                    sortable: true,
                    width: 125,
                },
                {
                    prop: "customer.name",
                    label: "Customer",
                    sortable: true,
                    width: 250,
                },
                {
                    prop: "date",
                    label: "Received",
                    sortable: true,
                    sortMethod: (a, b) => new Date(b.date) - new Date(a.date),
                    width: 125,
                },
                {
                    prop: "manufacturer.name",
                    label: "Manufacturer",
                    sortable: true,
                    width: 200,
                },
                {
                    prop: "designer.fullName",
                    label: "Designer",
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "customerJobId",
                    label: "Job Id",
                    sortable: true,
                    width: 225,
                },
                {
                    prop: "jobOrderNumber",
                    label: "Job Order No.",
                    sortable: true,
                    width: 175,
                },
                {
                    prop: "purchaseOrder",
                    label: "PO",
                    sortable: true,
                    width: 175,
                },
                {
                    prop: "materialType",
                    label: "Materials Rcvd",
                    sortable: true,
                    width: 175,
                },
                {
                    prop: "availableStock",
                    label: "Available",
                    sortable: false,
                    width: 125,
                },
            ];
            // eslint-disable-next-line max-len
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
        unRequestedReceiptLogs() {
            return this.receiptLogs.filter((log) => !log.deliveryRequested);
        },
    },
    watch: {
        clearSelection(clear) {
            if (clear) {
                this.selection = [];
            }
        },
        selection(items) {
            this.$emit("selectionChange", items);
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
        showDetail(row, column, $event) {
            if ($event.target.className.includes("el-checkbox")) return;
            if (column.label === "Actions") return;
            this.$router.push(`/receipt/${row.id}`);
        },
        getProp(object, property) {
            return _.get(object, property);
        },
        isChecked(item) {
            return this.selection.findIndex((log) => item.id === log.id) !== -1;
        },
        selectionChange(item, checked) {
            if (checked) {
                this.selection.push(item);
            } else {
                const index = this.selection.findIndex((i) => i.id === item.id);
                if (index !== -1) {
                    this.selection.splice(index, 1);
                }
            }
        },
        toggleAllSelection(checked) {
            if (checked) {
                this.selection = [...this.unRequestedReceiptLogs];
            } else {
                this.selection = [];
            }
        },
        rowClassName({ row }) {
            if (row.storageFeeInfo.oneWeekOrLess)
                return this.$style.oneWeekOrLess;
            if (row.storageFeeInfo.accruing) return this.$style.accruingFees;
            return "";
        },
    },
};
</script>

<style module>
.availableColumn {
    cursor: pointer;
}
.oneWeekOrLess {
    background-color: #ffecc8 !important;
}
.accruingFees {
    background-color: rgba(255, 0, 0, 0.3) !important;
}

.legend {
    display: flex;
}
.item {
    display: flex;
    padding-right: 20px;
}
.colorBox {
    width: 20px;
    height: 20px;
    display: inline-flex;
    margin-right: 10px;
    border: 1px solid gray;
}
</style>
